export default __webpack_public_path__ + "static/media/accomplished-579.c9572b2e.mp3";